import { useLayoutEffect, useRef, useState } from "react";

/**
 * Measures the rendered dropdown panel and flips it to right-aligned
 * if it would overflow the right edge of the viewport.
 */
export function useDropdownAlignment(isOpen: boolean) {
  const panelRef = useRef<HTMLDivElement>(null);
  const [alignRight, setAlignRight] = useState(false);

  useLayoutEffect(() => {
    if (!isOpen) {
      setAlignRight(false);
      return;
    }
    if (!panelRef.current) return;
    const rect = panelRef.current.getBoundingClientRect();
    setAlignRight(rect.right > window.innerWidth - 8);
  }, [isOpen]);

  return { panelRef, alignRight };
}
